<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-right-small">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M9.2131 18.0204C9.01784 17.8251 9.01784 17.5085 9.2131 17.3133L14.5262 12.0002L9.2131 6.68705C9.01783 6.49179 9.01783 6.1752 9.2131 5.97994C9.40836 5.78468 9.72494 5.78468 9.9202 5.97994L15.5869 11.6466C15.7821 11.8419 15.7821 12.1585 15.5869 12.3537L9.9202 18.0204C9.72494 18.2156 9.40836 18.2156 9.2131 18.0204Z" fill="#212328"/>
</g>
</svg>
